<template>
  <b-navbar
    toggleable="md"
    type="light"
    variant="transparent"
    class="main-navbar"
  >
    <b-navbar-brand v-if="showLogo" v-track-click id="header-logo">
      <img
        src="@/assets/images/common/logo-dark.svg"
        alt="Error Icon"
        height="40"
      />
    </b-navbar-brand>
  </b-navbar>
</template>
<script>
export default {
  props: {
    showLogo: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/variables';

.main-navbar {
  border-bottom: 1px solid $gray-300;
  margin-bottom: 20px;
}
</style>
